import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useCart } from "../contexts/CartContext";
import "./Nav.scss";

const Nav = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { toggleCart, getCartCount } = useCart();
  const cartCount = getCartCount();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="Nav">
      <div id="navContainer">
        <Link
          to="/"
          className="main-logo-link"
          aria-label="Spinnin' Beans home"
          onClick={() => setIsMenuOpen(false)}
        >
          <img src="/assets/sblogo.png" alt="Spinnin' Beans" id="mainLogo" />
        </Link>
        <button
          className={`menu-toggle ${isMenuOpen ? "open" : ""}`}
          onClick={toggleMenu}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <div id="navLinks" className={isMenuOpen ? "open" : ""}>
          <Link to="/" onClick={toggleMenu}>
            Home
          </Link>
          {/* <Link to="/discover" onClick={toggleMenu}>Discover</Link> */}
          {/* <Link to="/about" onClick={toggleMenu}>About</Link> */}
          <Link to="/dig" onClick={toggleMenu}>
            DIG
          </Link>
          <Link to="/artistspotlight" onClick={toggleMenu}>
            Artist Spotlight
          </Link>
          <Link to="/shop" onClick={toggleMenu}>
            Shop
          </Link>
          {/* <Link to="/radio" onClick={toggleMenu}>Radio</Link> */}
          {/* <Link to="/playlists" onClick={toggleMenu}>Playlists</Link> */}
          <button className="cart-button" onClick={toggleCart}>
            Cart{" "}
            {cartCount > 0 && <span className="cart-count">{cartCount}</span>}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Nav;
